import NotificationsPage from 'notifications/components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchNotifications } from 'notifications';

export function mapStateToProps({ user, notifications }) {
  const userId = user.logged_in ? user.profile_data.id : null;
  const list = notifications.data.results;
  return {
    userId,
    list,
    pageCount: notifications.pageCount,
    currentPage: notifications.currentPage,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchNotifications,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsPage);
